import { render, staticRenderFns } from "./LiveEditorDialog.vue?vue&type=template&id=dafa595c&scoped=true"
import script from "./LiveEditorDialog.vue?vue&type=script&lang=js"
export * from "./LiveEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./LiveEditorDialog.vue?vue&type=style&index=0&id=dafa595c&prod&lang=scss&scoped=true"
import style1 from "./LiveEditorDialog.vue?vue&type=style&index=1&id=dafa595c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafa595c",
  null
  
)

export default component.exports